import { render, staticRenderFns } from "./BotaoVoltarTopo.vue?vue&type=template&id=64781599&scoped=true&"
import script from "./BotaoVoltarTopo.vue?vue&type=script&lang=js&"
export * from "./BotaoVoltarTopo.vue?vue&type=script&lang=js&"
import style0 from "./BotaoVoltarTopo.vue?vue&type=style&index=0&id=64781599&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64781599",
  null
  
)

export default component.exports